export default __webpack_public_path__ + "assets/overview-courier-smartphone.png";